import { getSiteUrl } from './siteConfig';

/** DNS TXT record host prefix (record is `_nexus-intake.{yourIntakeHostname}`). */
export const INTAKE_CUSTOM_HOST_TXT_PREFIX = '_nexus-intake';

export type IntakeCustomHostFields = {
  intake_custom_hostname?: string | null;
  intake_custom_host_verified_at?: string | null;
};

/** Strip scheme/path/port; lowercase host only. */
export function normalizeIntakeHostname(input: string): string {
  let s = (input || '').trim().toLowerCase();
  s = s.replace(/^https?:\/\//, '');
  s = s.split('/')[0] || '';
  s = s.split(':')[0] || '';
  return s;
}

/** Public https origin for intake links when custom host is verified; otherwise main app URL. */
export function getIntakePublicOriginFromBusinessRow(business: IntakeCustomHostFields | null | undefined): string {
  const host = normalizeIntakeHostname(String(business?.intake_custom_hostname ?? ''));
  const verified = Boolean(business?.intake_custom_host_verified_at);
  if (host && verified) {
    return `https://${host}`;
  }
  return getSiteUrl();
}

export function buildPublicIntakeUrl(accessToken: string, publicOrigin: string): string {
  const base = (publicOrigin || getSiteUrl()).replace(/\/$/, '');
  return `${base}/intake/${accessToken}`;
}
